import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { doc, onSnapshot } from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import { db } from "../firebase";

export default function ProtectedRoute() {
  const { currentUser } = useAuth();
  const location = useLocation();
  const [profileData, setProfileData] = React.useState(null);
  const [loadingProfile, setLoadingProfile] = React.useState(true);

  React.useEffect(() => {
    if (!currentUser) {
      setProfileData(null);
      setLoadingProfile(false);
      return;
    }

    setLoadingProfile(true);
    const unsub = onSnapshot(
      doc(db, "profilsUsers", currentUser.uid),
      (snap) => {
        setProfileData(snap.exists() ? snap.data() : null);
        setLoadingProfile(false);
      },
      (error) => {
        console.error("ProtectedRoute profile load failed:", error);
        setProfileData(null);
        setLoadingProfile(false);
      }
    );

    return () => unsub();
  }, [currentUser]);

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (loadingProfile) {
    return null;
  }

  const pathname = location.pathname || "";
  const isProfileRoute = pathname.startsWith("/app/profile");
  const isOnboardingRoute = pathname.startsWith("/app/onboarding");
  const hasCompanyName = Boolean(profileData?.companyName?.trim());
  const onboardingCompleted = Boolean(profileData?.onboardingCompleted);

  if (!hasCompanyName && !isProfileRoute) {
    return <Navigate to="/app/profile" replace />;
  }

  if (!hasCompanyName && isOnboardingRoute) {
    return <Navigate to="/app/profile" replace />;
  }

  if (hasCompanyName && !onboardingCompleted && !isOnboardingRoute) {
    return <Navigate to="/app/onboarding" replace />;
  }

  if (hasCompanyName && onboardingCompleted && isOnboardingRoute) {
    return <Navigate to="/app" replace />;
  }

  if (hasCompanyName && !onboardingCompleted && isProfileRoute) {
    return <Navigate to="/app/onboarding" replace />;
  }

  return <Outlet />;
}
